module.exports = __webpack_public_path__ + "static/kids-a911117b399234d2bfa85d367cfe7cd2.jpg";